import { render, staticRenderFns } from "./ProjectDialog.vue?vue&type=template&id=5abd8ffa"
import script from "./ProjectDialog.vue?vue&type=script&lang=js"
export * from "./ProjectDialog.vue?vue&type=script&lang=js"
import style0 from "./ProjectDialog.vue?vue&type=style&index=0&id=5abd8ffa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports